/**
 * Constants and type definitions for Risk Calculator
 * All string values are keys for i18n translation
 */

// Calculator steps
export const STEPS = {
  CULTURES: 1,
  TREATMENT_TYPE: 2,
  APPLICATION_TECHNIQUE: 3,
  COMMERCIAL_PRODUCTS: 4,
};

export const STEP_KEYS = {
  1: 'CULTURES',
  2: 'TREATMENT_TYPE',
  3: 'APPLICATION_TECHNIQUE',
  4: 'COMMERCIAL_PRODUCTS',
};

export const TOTAL_STEPS = 4;

// Step configuration for wizard
export const STEP_CONFIG = [
  {
    key: STEPS.CULTURES,
    titleKey: 'step_1_title',
    numberKey: 'step_1_number',
  },
  {
    key: STEPS.TREATMENT_TYPE,
    titleKey: 'step_2_title',
    numberKey: 'step_2_number',
  },
  {
    key: STEPS.APPLICATION_TECHNIQUE,
    titleKey: 'step_3_title',
    numberKey: 'step_3_number',
  },
  {
    key: STEPS.COMMERCIAL_PRODUCTS,
    titleKey: 'step_4_title',
    numberKey: 'step_4_number',
  },
];

// Risk levels
export const RISK_LEVELS = {
  LOW: 'LOW',
  MODERATE: 'MODERATE',
  HIGH: 'HIGH',
  VERY_HIGH: 'VERY_HIGH',
};

// Colors from Figma design
export const COLORS = {
  PRIMARY_GREEN_DARK: '#083D26',
  PRIMARY_GREEN: '#105235',
  PRIMARY_GREEN_LIGHT: '#207D54',
  ACCENT_LIME: '#A0D911',
  ACCENT_YELLOW: '#FFD666',
  BACKGROUND_LIGHT: '#F5F5F5',
  BACKGROUND_WHITE: '#FFFFFF',
  TEXT_PRIMARY: '#141414',
  TEXT_SECONDARY: '#8C8C8C',
};

// API endpoints
export const API_ENDPOINTS = {
  CULTURES: '/api/cultures/tree/',
  CULTURES_DETAIL: '/api/cultures/', // For fetching individual culture details
  TREATMENT_TYPES: '/api/treatments/treatment-types/',
  APPLICATION_TECHNIQUES: '/api/treatments/techniques-application-places/',
  COMMERCIAL_PRODUCTS: '/api/commercial-products/',
  CALCULATE_RISKS: '/api/active-substances/risk-indices/calculate/',
  UNITS: '/api/treatments/units/',
  // Bulk validation for proactive mismatch detection in edit/duplicate mode
  VALIDATE_SELECTIONS: '/api/treatments/risk-calculator-validate/',
};

